<template lang="html">
  <ExtForm
    :formData="form.data"
    :submitProxy="form.submitProxy"
    @submitSuccess="login"
    submitBtnText="Войти"
  >
    <b-form-fieldset
      label="Логин"
      :class="{'is-invalid': errors.has('login') }"
      :feedback="errors.first('login')"
    >
      <input class="form-control" v-model.trim.lazy="form.data.login" v-validate="'required|eng'" name="login">
    </b-form-fieldset>
    <b-form-fieldset
      label="Пароль"
      :class="{'is-invalid': errors.has('password') }"
      :feedback="errors.first('password')"
    >
      <input class="form-control" type="password" v-model.trim.lazy="form.data.password" name="password" v-validate="'required'">
    </b-form-fieldset>
  </ExtForm>
</template>

<script>
import ExtForm from '@/components/ExtForm'

export default {
  data () {
    return {
      form: {
        data: {
          login: '',
          password: ''
        },
        submitProxy: {
          url: 'auth/login',
          method: 'post'
        }
      }
    }
  },
  methods: {
    login (data) {
      this.$store.dispatch('login', data)
      this.$router.push({name: 'UserProfile'})
      // if (this.$router.currentRoute.name === 'Login') {

      // }
    }
  },
  components: {
    ExtForm
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LoginForm.vue?649545ba